import { CREATE_OR_UPDATE_SERVICE } from "../../routes";
import customAxios from "../../customAxios";

type Props = {
  nationalCode: string;
  firstName   : string;
  lastName    : string;
  parent      : string;
  school      : string;
  driver      : string;
  gender      : string;
  price       : string;
  expire      : string;
  city      : string;
  province      : string;

  address?: string;
}

async function createOrUpdateService(props: Props): Promise<any> {
  try {
    return (await customAxios.post(CREATE_OR_UPDATE_SERVICE, props)).data;
  } catch (error: any) {
    console.error({ CREAT_OR_UPDATE_PARENT: error });
  }
}

export default createOrUpdateService;
